import styled from 'styled-components';
import { device } from 'src/styles/global';
import { TextField } from '@dsny/dsny-component-library';
import theme from 'src/styles/theme';

export const TextFieldWrapper = styled(TextField)`
  font-size: 14px;

  @media ${device.mobile} {
    width: 100%;
  }
`;

export const SearchWrapperStyles = {
  paddingRight: '0px',
  marginBottom: '0px',
};

export const SearchInputStyles = {
  height: '44px',
  borderRadius: '5px',
  color: theme.colors.neutralW40,
};

export const SearchTailingStyles = {
  paddingTop: '20px',
  paddingRight: '10px',
};
